export default __webpack_public_path__ + "static/media/shirt8.a6967a99.jpeg";